import { render } from "./settings.vue?vue&type=template&id=1635be14&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=1635be14&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1635be14"]])

export default __exports__